/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_SingleInputs */



/**
* | output |
* | --- |
* | "Single (♪)" |
*
* @param {Music_Notes_SingleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_single = /** @type {((inputs?: Music_Notes_SingleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_SingleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Simple (♪)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Single (♪)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Singolo (♪)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Холост/Не замужем (♪)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Soltero (♪)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("单曲 (♪)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シングル（♪）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकल (♪)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Solteiro (♪)")
	return /** @type {LocalizedString} */ ("Single (♪)")
});